module.exports = __webpack_public_path__ + "static/media/salvusatas_logo_login.d2f3a351.png";